module.exports = __webpack_public_path__ + "static/media/300_11.fde8b07c.jpg";